import { render } from "./UserContractsComponent.vue?vue&type=template&id=20f1dda8&scoped=true"
import script from "./UserContractsComponent.vue?vue&type=script&lang=js"
export * from "./UserContractsComponent.vue?vue&type=script&lang=js"

import "./UserContractsComponent.vue?vue&type=style&index=0&id=20f1dda8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f1dda8"]])

export default __exports__